import { invariant as k, omit as F, pick as G, getKeys as H, chain as j, hasOwnProperty as O, applyState as J, noop as Q } from "./PBFD2E7P.js";
import { __spreadProps as R, __spreadValues as T } from "./3YLGPPWQ.js";
function m(r, s) {
  const e = r.__unstableInternals;
  return k(e, "Invalid store"), e[s];
}
function q(r, ...s) {
  let e = r, b = e, g = Symbol(), c = Q;
  const a = /* @__PURE__ */ new Set(), f = /* @__PURE__ */ new Set(), w = /* @__PURE__ */ new Set(), V = /* @__PURE__ */ new Set(), K = /* @__PURE__ */ new Set(), d = /* @__PURE__ */ new WeakMap(), _ = /* @__PURE__ */ new WeakMap(), x = (t) => (w.add(t), () => w.delete(t)), A = () => {
    const t = a.size, n = Symbol();
    a.add(n);
    const u = () => {
      a.delete(n), !a.size && c();
    };
    if (t) return u;
    const l = H(e).map(
      (i) => j(
        ...s.map((p) => {
          var o;
          const h = (o = p == null ? void 0 : p.getState) == null ? void 0 : o.call(p);
          if (h && O(h, i))
            return Y(p, [i], (v) => {
              z(
                i,
                v[i],
                // @ts-expect-error - Not public API. This is just to prevent
                // infinite loops.
                !0
              );
            });
        })
      )
    ), S = [];
    for (const i of w)
      S.push(i());
    const I = s.map(X);
    return c = j(...l, ...S, ...I), u;
  }, y = (t, n, u = V) => (u.add(n), _.set(n, t), () => {
    var l;
    (l = d.get(n)) == null || l(), d.delete(n), _.delete(n), u.delete(n);
  }), B = (t, n) => y(t, n), C = (t, n) => (d.set(n, n(e, e)), y(t, n)), D = (t, n) => (d.set(n, n(e, b)), y(t, n, K)), L = (t) => q(G(e, t), P), N = (t) => q(F(e, t), P), U = () => e, z = (t, n, u = !1) => {
    var l;
    if (!O(e, t)) return;
    const S = J(n, e[t]);
    if (S === e[t]) return;
    if (!u)
      for (const o of s)
        (l = o == null ? void 0 : o.setState) == null || l.call(o, t, S);
    const I = e;
    e = R(T({}, e), { [t]: S });
    const i = Symbol();
    g = i, f.add(t);
    const p = (o, h, v) => {
      var E;
      const M = _.get(o), $ = (W) => v ? v.has(W) : W === t;
      (!M || M.some($)) && ((E = d.get(o)) == null || E(), d.set(o, o(e, h)));
    };
    for (const o of V)
      p(o, I);
    queueMicrotask(() => {
      if (g !== i) return;
      const o = e;
      for (const h of K)
        p(h, b, f);
      b = o, f.clear();
    });
  }, P = {
    getState: U,
    setState: z,
    __unstableInternals: {
      setup: x,
      init: A,
      subscribe: B,
      sync: C,
      batch: D,
      pick: L,
      omit: N
    }
  };
  return P;
}
function et(r, ...s) {
  if (r)
    return m(r, "setup")(...s);
}
function X(r, ...s) {
  if (r)
    return m(r, "init")(...s);
}
function nt(r, ...s) {
  if (r)
    return m(r, "subscribe")(...s);
}
function Y(r, ...s) {
  if (r)
    return m(r, "sync")(...s);
}
function rt(r, ...s) {
  if (r)
    return m(r, "batch")(...s);
}
function st(r, s) {
  if (process.env.NODE_ENV === "production" || !s) return;
  const e = Object.entries(r).filter(([c, a]) => c.startsWith("default") && a !== void 0).map(([c]) => {
    var a;
    const f = c.replace("default", "");
    return `${((a = f[0]) == null ? void 0 : a.toLowerCase()) || ""}${f.slice(1)}`;
  });
  if (!e.length) return;
  const b = s.getState();
  if (e.filter(
    (c) => O(b, c)
  ).length)
    throw new Error(
      `Passing a store prop in conjunction with a default state is not supported.

const store = useSelectStore();
<SelectProvider store={store} defaultValue="Apple" />
                ^             ^

Instead, pass the default state to the topmost store:

const store = useSelectStore({ defaultValue: "Apple" });
<SelectProvider store={store} />

See https://github.com/ariakit/ariakit/pull/2745 for more details.

If there's a particular need for this, please submit a feature request at https://github.com/ariakit/ariakit
`
    );
}
export {
  rt as batch,
  q as createStore,
  X as init,
  et as setup,
  nt as subscribe,
  Y as sync,
  st as throwOnConflictingProps
};
//# sourceMappingURL=BCALMBPZ.js.map
